export default __webpack_public_path__ + "static/media/026-tent.70e6c474.svg";